import { Box } from "@mui/material";
import React from "react";

import UserInfoForm from "./UserInfoForm";
import UserPassword from "./UserPassword";

const UserMain = () => {
  return (
    <Box>
      <UserInfoForm />
      <UserPassword />
    </Box>
  );
};

export default UserMain;
